import { render, staticRenderFns } from "./chat-invites.vue?vue&type=template&id=7a21c4d2&"
import script from "./chat-invites.vue?vue&type=script&lang=js&"
export * from "./chat-invites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports